import {defineStore} from 'pinia';

export const CommentStore = defineStore('comment', {
    state: () => ({
        parent_comment_id: null,
    }),
    getters: {
        data: (state) => state.parent_comment_id,
    },
    actions: {
        setParent(parent_comment_id) {
            this.parent_comment_id = parent_comment_id;
        }
    },
})
